import { withDataFilter } from '@/store/index';

const store = {
  namespaced: true
};

export default withDataFilter(store);
